import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import { getAuctionEventById } from "services";
import LeftArrowAccordian from "../../../icons/LeftArrowAccordian";
import BidderDetailsWrapper from "./BiddersDetailWrapper";
import JointBidderCountModal from "./JointBidder/JBCountModal";
import AnimatedDropdown from "../../../shadcn/components/custom/dropdown/CustomAnimatedDropdown";
import NIBidderTypeModal from "./NonIndividual/NIBidderTypeModal";
import { Button } from "../../../shadcn/components/ui/button";

export default function ViewBidders() {
  const router = useRouter();
  const { for_event } = router.query;
  const [event, setEvent] = useState<any>([]);
  const [showJointBidderModal, setShowJointBidderModal] = useState(false);
  const [showNIBidderTypeModal, setShowNIBidderTypeModal] = useState(false);

  useEffect(() => {
    if (for_event) {
      (async () => {
        await init(for_event);
      })();
    }
  }, [for_event]);

  const init = async (id: any) => {
    const data: any = await getAuctionEventById(id);
    setEvent(data);
  };

  const handleJointBidderSubmit = async (bidderCount: number) => {
    if (for_event) {
      router.push(
        `/dashboard/bidders/create?for_event=${for_event}&bidders_count=${bidderCount}&bidder_type=joint`
      );
    }
  };

  const handleJointBidderCancel = () => {
    setShowJointBidderModal(false);
  };

  const handleNIBidderTypeSubmit = async (type: string) => {
    if (for_event) {
      router.push(
        `/dashboard/bidders/create?for_event=${for_event}&bidder_type=${type}`
      );
    }
  };

  const handleNIBidderTypeCancel = () => {
    setShowNIBidderTypeModal(false);
  };

  const dropdownOptions = [
    { label: "Individual", value: "individual" },
    { label: "Non Individual", value: "non_individual" },
    { label: "Joint Participation", value: "joint" },
  ];

  const handleOptionClick = (option: { label: string; value: string }) => {
    if (for_event) {
      if (option.value === "joint") {
        setShowJointBidderModal(true);
      } else if (option.value === "individual") {
        router.push(
          `/dashboard/bidders/create?for_event=${for_event}&bidder_type=individual`
        );
      } else if (option.value === "non_individual") {
        setShowNIBidderTypeModal(true);
      }
    }
  };

  return (
    <div className="px-4 lg:px-8 py-6">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <button
            onClick={() => {
              router.back();
            }}
          >
            <LeftArrowAccordian className="h-6 w-6" />
          </button>
          <p className="font-openSans font-normal text-web-subheading leading-6 ml-5 text-bankerColor">
            Bidders
          </p>
        </div>

        {process.env.NEXT_PUBLIC_JBP_ENABLE === "true" ? (
          <AnimatedDropdown
            options={dropdownOptions}
            onOptionClick={handleOptionClick}
            triggerText="Add Bidders"
            triggerClassName="max-w-[200px]"
            disabled={
              event?.status === "end" ||
              event?.status === "rejected" ||
              event?.status === "cancelled"
            }
          />
        ) : (
          <Button
            disabled={
              event?.status === "end" ||
              event?.status === "rejected" ||
              event?.status === "cancelled"
            }
            onClick={() => {
              if (for_event)
                router.push(`/dashboard/bidders/create?for_event=${for_event}`);
            }}
            className={`font-openSans font-semibold h-8 md:h-10 md:px-3 px-2 py-0.5 text-[10px] md:text-web-body-sm text-white`}
          >
            Add bidders
          </Button>
        )}
      </div>
      <div className="mt-4 border-2 border-gray-100">
        <BidderDetailsWrapper eventData={event} />
      </div>
      {showJointBidderModal && (
        <JointBidderCountModal
          onSubmit={handleJointBidderSubmit}
          onCancel={handleJointBidderCancel}
          redirectUrl=""
        />
      )}

      {showNIBidderTypeModal && (
        <NIBidderTypeModal
          onSubmit={handleNIBidderTypeSubmit}
          onCancel={handleNIBidderTypeCancel}
          redirectUrl=""
        />
      )}
    </div>
  );
}
